function quantityNumber(){

  var currentUrl = window.location.href;
  var newUrl = new URL(currentUrl);
  var qntyUrl = newUrl.searchParams.get("quantity");


  if (window.location.toString().includes("quantity")) {
    document.getElementById("qntyNumb").value = qntyUrl; 
    document.querySelector(".AlertBlock").removeAttribute("hidden");
  }

}
function responsiveReposition(){
  function handleResize(){
    if (window.innerWidth < 999 && mobilePositionElements) {
      mobilePositionElements.forEach((el)=>{
        const target = document.querySelector(el.getAttribute('data-mobileposition'));
        if(target){
          target.insertAdjacentElement('afterend', el);
        }
      })
    } else if(desktopPositionElements) {
      desktopPositionElements.forEach((el)=>{
        const target = document.querySelector(el.getAttribute('data-deskposition'));
        if(target){
          target.insertAdjacentElement('afterend', el);
        }
      })
    }
  }

  const mobilePositionElements = document.querySelectorAll('[data-mobileposition]');
  const desktopPositionElements = document.querySelectorAll('[data-deskposition]');

  if(mobilePositionElements || desktopPositionElements){
    window.addEventListener('resize', (e)=>{
      handleResize();
    });
    handleResize();
  }
}

document.addEventListener('DOMContentLoaded', ()=>{
  quantityNumber();
  responsiveReposition();
})